import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import avatar from '../../Pics/avatar.jpg'

import SpecificComponent from '../SpecificComponent'
import { Fab, FormControl, InputLabel, Select, MenuItem, Input, Grid, Checkbox, Switch } from '@material-ui/core';
import Utils from '../../providers/Utils';
import PropTypes from 'prop-types';
import Ws from '../../providers/Ws';
import OpenAddFisaPostului from './OpenAddFisaPostului';
import OpenAddCV from './OpenAddCV';
import AlertDialog from './AlertDialog';
import ListaAccesDepartamente from '../../module/administrare/ListaAccesDepartamente';
import Masks from '../../providers/Masks';

import { ReactComponent as TrashW } from '../../Pics/iconsManagementUtilizatori/Trash_white.svg';

import { ReactComponent as Program } from '../../Pics/iconsManagementUtilizatori/Program.svg';

export default class NewUserDrepturi extends SpecificComponent {

    constructor(props) {
        super(props)
        this.state = {
            isFirmaExterna: false,
            valuta_optiuni: ['lei', '$', '€'],
            valuta: 'lei',
            isOpenAlert: false,
            isOpenFisa: false,
            isOpenCv: false,
            vCnp: '',
            vTel: ''
        }
    }

    ws = new Ws()
    m = new Masks()

    //fisaPost adresaMedia + /Angajati/FisePost


    uploadPoza = async (id, idAngajat, bkId) => {


        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);

        let chPoza = document.getElementById(bkId)




        reader.onload = async () => {
            let fileContent = reader.result;
            chPoza.style.backgroundImage = ` url(${fileContent})`
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadimage('Upload/PozaAngajat', saveFile, idAngajat);

            // console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {




            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }

    }


    selectFile = (id) => {

        //  console.log('Incepe poza');
        let pi = document.getElementById(id);

        pi.click()

    }

    uploadFisaPostului = async (id, idAngajat) => {


        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);





        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadimage('Upload/FisaPostuluiAngajat', saveFile, idAngajat);

            console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {
                // this.props.getData(this.props.angajat)

                this.setState({ isOpenFisa: false })
            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }

    }

    uploadCV = async (id, idAngajat) => {


        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);





        reader.onload = async () => {
            let fileContent = reader.result;
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadimage('Upload/CvAngajat', saveFile, idAngajat);

            // console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {
                // this.props.getData(this.props.angajat)

                this.setState({ isOpenCv: false })
            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }

    }

    openFisaPostului = async () => {


        if (this.props.angajat.doc_fisa_postului) {
            let adresaFisa = new Ws().adresaMedia + `/Angajati/FisePost/${this.props.angajat.doc_fisa_postului}`

            // console.log('adresaFisa :>> ', adresaFisa);
            // window.open(adresaFisa)

            // window.open(`/#projectdetails/55/1`)


            // https://proiecte.totalsoftware.ro/Storage/Media/Angajati/FisePost/q2fc1hvmrnrwoorxk3dfxa1p2jsj55mk.docx

            await this.ws.downloadFile('FisaPostuluiAngajat', this.props.angajat.doc_fisa_postului)





        } else {
            this.setState({
                isOpenAlert: true,
                strAlertMesaj: 'Nu exista fisa postului !'
            })
        }

    }


    openCv = () => {

        if (this.props.angajat.cv) {
            let adresaFisa = new Ws().adresaMedia + `/Angajati/Cv/${this.props.angajat.cv}`

            window.open(adresaFisa)
        } else {
            this.setState({
                isOpenAlert: true,
                strAlertMesaj: 'Nu exista CV !'
            })
        }

    }


    validateInput = (n) => {
        let ang = { ...this.props.angajat }

        if (n === 'cnp') {
            let substrCnp1stLetter = ang[n].substring(0, 1)





            let substrCnpLuna = ang[n].substring(3, 5)




            let substrCnpZi = ang[n].substring(5, 7)



            let cnpLength = ang[n].length

            let cnpValidate = false

            console.log('substrCnpZi :>> ', substrCnpZi);

            if (substrCnp1stLetter > 0 && substrCnp1stLetter <= 5) {
                console.log('substrCnp1stLetter :>> ', substrCnp1stLetter);
                cnpValidate = true

                if (Number(substrCnpLuna) > 0 && Number(substrCnpLuna) <= 12) {
                    console.log('substrCnpLuna :>> ', substrCnpLuna);
                    cnpValidate = true
                    let nDate = new Date().setMonth(Number(substrCnpLuna) - 1)
                    nDate = new Date(nDate)
                    let lastDayMonth = new Date(this.m.lastDayMonth(nDate)).getDate()

                    console.log('lastDayMonth :>> ', lastDayMonth);
                    console.log('this.m.lastDayMonth(nDate) :>> ', this.m.lastDayMonth(nDate));
                    if (Number(substrCnpZi) > 0 && Number(substrCnpZi) <= lastDayMonth) {
                        console.log('substrCnpZi :>> ', substrCnpZi);
                        cnpValidate = true

                        if (cnpLength === 13) {
                            cnpValidate = true
                        } else {
                            cnpValidate = false
                        }
                    } else {
                        cnpValidate = false
                    }


                } else {
                    cnpValidate = false
                }
            }








            if (cnpValidate) {
                this.setState({ vCnp: '' })
            } else {
                this.setState({ vCnp: this.dictionary.managementUtilizatori.verifyCnp })
            }
        } else if (n === 'telefon') {

            let telValidate = false

            if (ang[n].length === 10) {

                telValidate = true
            }


            if (telValidate) {
                this.setState({ vTel: '' })
            } else {
                this.setState({ vTel: this.dictionary.managementUtilizatori.verifyTel })
            }
        }
    }








    render() {
        return (
            <div>
                <Dialog
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    fullWidth={true}
                    maxWidth={'md'}

                >

                    <DialogActions>
                        <Fab onClick={this.props.dialogClose}
                            className="pm-round-button-dialog"
                            style={{ boxShadow: 'none', backgroundColor: 'transparent' }}
                        >
                            <i style={{ color: 'black', fontSize: 28, fontWeight: 500 }} className='material-icons'>close</i>
                        </Fab>
                    </DialogActions>









                    {/* 
                    <h2 style={{ marginBottom: 5 }} className="pm-title">Utilizator Nou</h2>
                    <div style={{ textAlign: 'center', width: 'fit-content', margin: 'auto', padding: 5, border: '1px solid #d4d4d4' }}>
                        <span style={{ fontWeight: 600, color: !this.props.isFirmaExterna ? '#11d811' : '#b7b7b7' }}>Departament Intern</span>
                        <Switch
                            className={!this.props.isFirmaExterna ? '' : "pm-switch"}
                            checked={this.props.isFirmaExterna}
                            onChange={(ev) => { this.props.changeFirma(ev) }}
                            value='companie'
                        />
                        <span style={{ fontWeight: 600, color: this.props.isFirmaExterna ? '#11d811' : '#b7b7b7' }}>Firma Externa</span>
                    </div> */}


                    <DialogContent style={{ width: '90%', margin: 'auto', }}>
                        <Grid style={{ width: '90%', margin: 'auto' }} container>
                            <Grid style={{ position: 'relative' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                <div className='fix-line'></div>

                                <input type='file' id={`file${this.props.angajat.id}`}
                                    style={{ display: 'none' }}
                                    accept='image/*'
                                    onChange={() => { this.uploadPoza(`file${this.props.angajat.id}`, this.props.angajat.id, 'angajat-upload-poza') }} />


                                <div

                                    id={'angajat-upload-poza'}
                                    onClick={() => { this.selectFile(`file${this.props.angajat.id}`) }}
                                    className='pm-angajati-picture-update'
                                    style={{
                                        backgroundImage: `url('${this.props.angajat.poza ? (new Ws().adresaMedia + '/Angajati/' + this.props.angajat.poza) : avatar}')`,
                                        left: 0, top: 10
                                    }}>

                                </div>
                            </Grid>
                            <Grid style={{ paddingTop: 20, }} item xs={9} sm={9} md={9} lg={9} xl={9}>
                                <Grid container>
                                    <Grid style={{ position: 'relative' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <label className='inputLabelPM' htmlFor='nume'>{this.dictionary.proiecte.name}</label>
                                        <input
                                            id='nume'
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='nume'
                                            value={this.props.angajat.nume || ''}
                                            onChange={this.props.changeData}
                                            placeholder={this.dictionary.proiecte.userName}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid container>
                                            <Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
                                                <span style={{ fontWeight: 600, color: 'black', fontSize: 14 }}>{this.dictionary.proiecte.departamentIntern}</span>
                                                <div style={{ display: 'inline-block' }}>
                                                    <Switch
                                                        className={!this.props.isFirmaExterna ? '' : "pm-switch"}
                                                        disabled={this.props.toUpdate ? (this.props.noOrg ? false : true) : false}
                                                        checked={this.props.isFirmaExterna}
                                                        onChange={(ev) => { this.props.changeFirma(ev) }}
                                                        value='companie'
                                                    />
                                                </div>

                                                <span style={{ fontWeight: 600, color: 'black', fontSize: 14 }}> {this.dictionary.proiecte.companieExterna}</span>
                                            </Grid>

                                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                <Grid container>

                                                    {this.props.toUpdate &&


                                                        <Grid style={{ textAlign: 'center', marginTop:10 }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                                                            {/* <span onClick={() => { this.setState({ isOpenCv: true }) }} style={{ marginRight: 20, fontSize: 14, cursor: 'pointer' }}><i style={{ verticalAlign: 'middle' }} className='material-icons'>description</i> {this.dictionary.proiecte.cV}</span>
<span onClick={() => this.setState({ isOpenFisa: true })} style={{ marginRight: 20, fontSize: 14, cursor: 'pointer' }}><i style={{ verticalAlign: 'middle' }} className='material-icons'>insert_drive_file</i> {this.dictionary.proiecte.fisaPostului}</span> */}

                                                            {!this.props.noProgram &&

                                                                <span onClick={this.props.openProgram} style={{ marginRight: 20, fontSize: 14, cursor: 'pointer' }}>
                                                                    <Program style={{ width: 20, height: 20, verticalAlign: 'middle', marginRight: 10 }} />
                                                                    {/* <i style={{ verticalAlign: 'middle' }} className='material-icons'>query_builder</i>  */}
                                                                    {this.dictionary.proiecte.program} </span>
                                                            }


                                                            <input type='file' id={`fisa-postului-file`}
                                                                style={{ display: 'none' }}
                                                                accept='.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf'
                                                                onChange={() => { this.uploadFisaPostului('fisa-postului-file', this.props.angajat.id) }} />

                                                            <input type='file' id={`CV-file`}
                                                                style={{ display: 'none' }}
                                                                accept='.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf'
                                                                onChange={() => { this.uploadCV('CV-file', this.props.angajat.id) }} />
                                                        </Grid>
                                                    }

                                                </Grid>

                                            </Grid>


                                        </Grid>


                                    </Grid>
                                </Grid>
                            </Grid>




                        </Grid>
                        <Grid style={{ width: '90%', margin: 'auto', marginTop: 40 }} container >

                            <Grid item  xs={6} sm={6} md={6} lg={6} xl={6} >
                                <Grid style={{ padding: 5 }} container>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <h4 className='pm-title' style={{ textAlign: 'left', fontSize: 14, fontWeight: 500, color: 'black' }}>
                                            <span style={{ display: 'inline-flex' }}> {this.dictionary.proiecte.datePersonale}</span>

                                        </h4>
                                    </Grid>

                                    <Grid item style={{ marginTop: 20, position: 'relative' }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <label className='inputLabelPM' htmlFor='cnp'> {this.dictionary.proiecte.cnp}</label>
                                        <input
                                            id='cnp'
                                            className='add-project-input'
                                            type="number"
                                            margin="normal"
                                            name='cnp'
                                            placeholder={this.dictionary.proiecte.cnp}
                                            value={this.props.angajat.cnp || ''}
                                            onChange={this.props.changeData}
                                            onBlur={() => { this.validateInput('cnp') }}
                                        />
                                        {this.state.vCnp &&
                                            <span style={{
                                                fontSize: 12,
                                                color: 'red',
                                                paddingLeft: 6
                                            }}>{this.state.vCnp}</span>
                                        }


                                    </Grid>

                                    <Grid item style={{ marginTop: 20, position: 'relative' }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <label className='inputLabelPM' htmlFor='adresa'>{this.dictionary.proiecte.adresa}</label>
                                        <input
                                            id='adresa'
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='adresa'
                                            placeholder={this.dictionary.proiecte.adresa}
                                            value={this.props.angajat.adresa || ''}
                                            onChange={this.props.changeData}
                                        />



                                    </Grid>

                                    <Grid item style={{ marginTop: 20, position: 'relative' }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <label className='inputLabelPM' htmlFor='oras'>{this.dictionary.proiecte.oras}</label>
                                        <input
                                            id='oras'
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='oras'
                                            placeholder={this.dictionary.proiecte.oras}
                                            value={this.props.angajat.oras || ''}
                                            onChange={this.props.changeData}
                                        />



                                    </Grid>

                                    <Grid item style={{ marginTop: 20, position: 'relative' }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.proiecte.telefon}</label>
                                        <input
                                            id='telefon'
                                            className='add-project-input'
                                            type="number"
                                            margin="normal"
                                            name='telefon'
                                            placeholder={this.dictionary.proiecte.telefon}
                                            value={this.props.angajat.telefon || ''}
                                            onChange={this.props.changeData}
                                            onBlur={() => { this.validateInput('telefon') }}
                                        />

                                        {this.state.vTel &&
                                            <span style={{
                                                fontSize: 12,
                                                color: 'red',
                                                paddingLeft: 6
                                            }}>{this.state.vTel}</span>
                                        }



                                    </Grid>

                                    <Grid item style={{ marginTop: 20, position: 'relative' }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <label className='inputLabelPM' htmlFor='email'>{this.dictionary.proiecte.email}</label>
                                        <input
                                            id='email'
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='email'
                                            placeholder={this.dictionary.proiecte.adresaEmail}
                                            value={this.props.angajat.email || ''}
                                            onChange={this.props.changeData}
                                        />

                                        {this.props.vEmail &&
                                            <span style={{
                                                fontSize: 12,
                                                color: 'red',
                                                paddingLeft: 6
                                            }}>{this.props.vEmail}</span>
                                        }

                                    </Grid>


                                    <Grid item style={{
                                        display: 'block'
                                        // !this.props.toUpdate ? 'block' : 'none'

                                        , marginTop: 20
                                    }}  xs={12} sm={12} md={12} lg={12} xl={12} >

                                        <input
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='parola'
                                            value={this.props.parola || ''}
                                            onChange={this.props.parolaChange}
                                            placeholder={this.dictionary.proiecte.password}
                                        />

                                        {this.props.vParola &&
                                            <span style={{
                                                fontSize: 12,
                                                color: 'red',
                                                paddingLeft: 6
                                            }}>{this.props.vParola}</span>
                                        }

                                    </Grid>

                                    {/* <Grid item style={{
                                        display: 'block'
                                        // !this.props.toUpdate ? 'block' : 'none'

                                        , marginTop: 20
                                    }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                        <input
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='repetParola'
                                            value={this.props.repetParola || ''}
                                            onChange={this.props.repetaParolaChange}
                                            placeholder={this.dictionary.proiecte.reapeatPassword}
                                        />



                                    </Grid> */}

                                </Grid>



                            </Grid>

                            <Grid item  xs={6} sm={6} md={6} lg={6} xl={6} >
                                <Grid style={{ padding: 5 }} container>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <h4 className='pm-title' style={{ textAlign: 'left', fontSize: 14, fontWeight: 500, color: 'black' }}>
                                            <span style={{ display: 'inline-flex' }}> {this.dictionary.proiecte.dateServiciu}</span>

                                        </h4>
                                    </Grid>

                                    <Grid item style={{
                                        display: 'block',
                                        // !this.props.isFirmaExterna ? 'block' : 'none', 
                                        marginTop: 22
                                    }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                        {console.warn('this.props.angajat :>> ', this.props.angajat)}
                                        <p style={{ margin: 4, fontSize: 14, textAlign: 'left' }} className="pm-title">
                                            <Checkbox style={{ color: '#000000', padding: 0, verticalAlign: 'text-bottom' }}
                                                onChange={this.props.changeManager}
                                                value={'sef_departament'}
                                                checked={this.props.angajat.sef_departament === 1 ? true : false} />

                                            <span style={{ color: 'black', verticalAlign: 'super' }}>{this.dictionary.proiecte.esteManager}</span>

                                        </p>


                                    </Grid>

                                    {this.props.angajat.sef_departament === 1 &&
                                        <Grid item style={{
                                            display: 'block',
                                            // !this.props.isFirmaExterna ? 'block' : 'none', 
                                            marginTop: 22
                                        }}  xs={12} sm={12} md={12} lg={12} xl={12} >

                                            <p style={{ margin: 4, fontSize: 14, textAlign: 'left' }} className="pm-title">
                                                <Checkbox style={{ color: '#000000', padding: 0, verticalAlign: 'text-bottom' }}
                                                    onChange={this.props.changeAccessFinanciar}
                                                    value={'access_financiar'}
                                                    checked={this.props.angajat.access_financiar === 1 ? true : false} />
                                                {this.dictionary.proiecte.accessFinanciar}</p>


                                        </Grid>
                                    }


                                    <Grid item style={{ display: !this.props.isFirmaExterna ? 'block' : 'none', marginTop: 20, position: 'relative' }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <label className='inputLabelPM' htmlFor='id_departament'>{this.dictionary.proiecte.department}</label>
                                        <select
                                            disabled={this.props.angajat.is_admin === 1}
                                            id='id_departament'
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='id_departament'
                                            value={this.props.angajat.id_departament || ''}
                                            onChange={this.props.changeData}
                                            placeholder={this.dictionary.proiecte.selectDepartment}
                                        >
                                            <option value={-1}>Selecteaza Departament</option>

                                            {this.props.angajat.is_admin !== 1 &&
                                                this.props.departamente.filter(d => d.id !== 1).map((l, idx) => {
                                                    return (
                                                        <option key={idx} value={l.id}>{l.nume}</option>
                                                    )
                                                })
                                            }

                                            {this.props.angajat.is_admin === 1 &&
                                                this.props.departamente.map((l, idx) => {
                                                    return (
                                                        <option key={idx} value={l.id}>{l.nume}</option>
                                                    )
                                                })
                                            }


                                        </select>


                                    </Grid>
                                    <Grid item style={{ display: this.props.isFirmaExterna ? 'block' : 'none', marginTop: 20, position: 'relative' }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <label className='inputLabelPM' htmlFor='firma'>{this.dictionary.proiecte.firma}</label>
                                        <input
                                            id='firma'
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='firma'
                                            placeholder={this.dictionary.proiecte.firma}
                                            value={this.props.angajat.firma || ''}
                                            onChange={this.props.changeData}
                                        />



                                    </Grid>

                                    <Grid item style={{ marginTop: 20, position: 'relative' }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <label className='inputLabelPM' htmlFor='functie'>{this.dictionary.proiecte.functie}</label>
                                        <input
                                            id='functie'
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='functie'
                                            value={this.props.angajat.functie || ''}
                                            onChange={this.props.changeData}
                                            placeholder={this.dictionary.proiecte.functie}
                                        />



                                    </Grid>

                                    <Grid item style={{ marginTop: 20, position: 'relative' }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <label className='inputLabelPM' htmlFor='salariu'>{this.dictionary.proiecte.salariu}</label>
                                        <input
                                            id='salariu'
                                            className='add-project-input'
                                            type="number"
                                            margin="normal"
                                            name='salariu'
                                            value={this.props.angajat.salariu || ''}
                                            onChange={this.props.changeData}
                                            placeholder={this.dictionary.proiecte.salariuBrut}
                                        />



                                    </Grid>

                                    <Grid item style={{ marginTop: 20, paddingRight: 20, position: 'relative' }}  xs={10} sm={10} md={10} lg={10} xl={10} >
                                        <label className='inputLabelPM' htmlFor='cost_minut'>{this.dictionary.proiecte.costOra}</label>
                                        <input
                                            id='cost_minut'
                                            className='add-project-input'
                                            type="number"
                                            margin="normal"
                                            name='cost_minut'
                                            value={this.props.angajat.cost_minut || ''}
                                            onChange={this.props.changeData}
                                            placeholder={this.dictionary.proiecte.costOra}
                                        />



                                    </Grid>

                                    <Grid item style={{ marginTop: 20 }}  xs={2} sm={2} md={2} lg={2} xl={2} >

                                        <select
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='salariu_moneda'
                                            value={this.props.angajat.salariu_moneda || ''}
                                            onChange={this.props.changeData}
                                        // placeholder='Selecteaza departament'
                                        >


                                            {this.state.valuta_optiuni.map((l, idx) => {
                                                return (
                                                    <option key={idx} value={l}>{l}</option>
                                                )
                                            })}

                                        </select>


                                    </Grid>

                                    <Grid item style={{ marginTop: 20, position: 'relative' }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <label className='inputLabelPM' htmlFor='nr_zile_concediu'>{this.dictionary.proiecte.nrZileConcediu}</label>
                                        <input
                                            id='nr_zile_concediu'
                                            className='add-project-input'
                                            type="number"
                                            margin="normal"
                                            name='nr_zile_concediu'
                                            value={this.props.angajat.nr_zile_concediu || ''}
                                            onChange={this.props.changeData}
                                            placeholder={this.dictionary.proiecte.nrZileConcediu}
                                        />



                                    </Grid>

                                    <Grid item style={{ marginTop: 20, position: 'relative' }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                        <label className='inputLabelPM' htmlFor='permis_conducere'>{this.dictionary.proiecte.permisConducere}</label>
                                        <input
                                            id='permis_conducere'
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='permis_conducere'
                                            value={this.props.angajat.permis_conducere || ''}
                                            onChange={this.props.changeData}
                                            placeholder={this.dictionary.proiecte.permisConducere}
                                        />



                                    </Grid>


                                </Grid>
                            </Grid>
                            {console.log('this.props.isFirmaExterna :>> ', this.props.isFirmaExterna)}

                            {!this.props.noDrepturi && this.props.angajat.sef_departament === 1 &&
                                <Grid item style={{ display: !this.props.isFirmaExterna ? 'block' : 'none', marginTop: 20, position: 'relative' }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                    <Grid container>
                                        <Grid item style={{ display: !this.props.isFirmaExterna ? 'block' : 'none', marginTop: 20, position: 'relative' }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                            <label className='inputLabelPM' htmlFor='id_departament'>{this.dictionary.proiecte.accesDepartamente}</label>
                                            <select
                                                id='id_departament_access'
                                                className='add-project-input'
                                                type="text"
                                                margin="normal"
                                                name='id_departament'
                                                value={this.props.idDepartament || ''}
                                                onChange={this.props.changeidDepartament}
                                                placeholder={this.dictionary.proiecte.selectDepartment}
                                            >

                                                <option value={0}>Selecteaza Departament</option>
                                                {this.props.departamente.map((l, idx) => {
                                                    return (

                                                        <option key={idx} value={l.id}>{l.nume}</option>
                                                    )
                                                })}

                                            </select>

                                        </Grid>
                                        <Grid item style={{ display: !this.props.isFirmaExterna ? 'block' : 'none', marginTop: 20, position: 'relative' }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                            <ListaAccesDepartamente
                                                departamente={this.props.dAccess}
                                                deleteDep={this.props.deleteDep}
                                            />
                                        </Grid>
                                    </Grid>




                                </Grid>
                            }








                            <Grid style={{ marginTop: 20, textAlign: 'center' }}  xs={12} sm={12} md={12} lg={12} xl={12} >
                                <Button
                                    style={{ boxShadow: 'none', marginRight: 10 }}
                                    className='add-button-green'
                                    variant="contained"
                                    color="primary"
                                    onClick={() => { this.props.updateAngajat() }}
                                >
                                    {this.props.limba.comune.save}
                                </Button>
                                {this.props.toUpdate && this.props.angajat.is_admin !== 1 &&
                                    <Button
                                        style={{ boxShadow: 'none' }}
                                        className='add-button-red '
                                        variant="contained"
                                        color="primary"
                                        onClick={() => { this.props.stergeAngajat() }}
                                    >

                                        <TrashW style={{ width: 20, height: 20 }} />
                                        {this.dictionary.proiecte.delete}
                                    </Button>
                                }

                            </Grid>
                        </Grid>

                    </DialogContent>



                </Dialog>


                <OpenAddFisaPostului
                    open={this.state.isOpenFisa}
                    dialogClose={() => { this.setState({ isOpenFisa: false }) }}
                    selectFile={this.selectFile}
                    openFisaPostului={this.openFisaPostului}
                    limba={this.props.limba}
                />



                <OpenAddCV
                    open={this.state.isOpenCv}
                    dialogClose={() => { this.setState({ isOpenCv: false }) }}
                    selectFile={this.selectFile}
                    openCV={this.openCv}
                    limba={this.props.limba}
                />




            </div >

        );
    }


}  // end class

